import React from "react";
import DateHelper from "../DateHelper/DateHelper";
import DataTable from "../DataTable/DataTable";
import numeral from "numeral"
import ModalButtons from "../ModalButtons/ModalButtons";

class ReservationCancel extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      notes: "",
    }
    this.onChangeNotes = this.onChangeNotes.bind(this)
  }

  render() {
    var self = this
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: [
          'data-dismiss="modal"'
        ]
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary'],
        onClick: function (e) {
          self.onCancel();
          return false;
        },
      },
    ]

    return(
      <div>
        <div className="row">
          <div className="col-sm-6">
            {this.renderReservationDetails()}
          </div>
          <div className="col-sm-6">
            {this.renderNotes()}
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            {this.renderRoomDetails()}
          </div>
        </div>
        {this.renderBalance()}
        <ModalButtons loading={this.state.loading} buttons={buttons} />
      </div>
    )
  }

  renderNotes() {
    return(
      <div className="form-group">
        <label>{I18n.t('notes')} <span className="ss-help" title={I18n.t('room_notes_helper_text')}></span></label>
        <textarea name="notes" rows="8" value={this.state.notes} className="form-control notes" onChange={this.onChangeNotes}></textarea>
      </div>
    )
  }

  renderReservationDetails() {
    var dateFormat = DateHelper.rubyToDateJS(this.props.date_format);
    var start_date = DateHelper.parseDate(this.props.reservation.start_date);
    var end_date = DateHelper.parseDate(this.props.reservation.end_date);
    var date_of_booking = DateHelper.parseDate(this.props.reservation.created_at)
    var cancellation_date = DateHelper.parseDate(this.props.cancellation_date)

    return(
      <div className='panel panel-default'>
        <div className="panel-heading">
          <h3 className='panel-title'>{I18n.t('reservation_details')}</h3>
        </div>
        <div className="panel-body">
          <div className="row">
            <div className="col-sm-6">
              <label>{I18n.t('begins')}</label>
              <div>{start_date.toString(dateFormat)}</div>
            </div>
            <div className="col-sm-6">
              <label>{I18n.t('ends')}</label>
              <div>{end_date.toString(dateFormat)}</div>
            </div>
          </div>
          <br />
          <br />
          <div className="row">
            <div className="col-sm-6">
              <label>{I18n.t('booked_by')}</label>
              <div>{this.props.booked_by}</div>
            </div>
            <div className="col-sm-6">
              <label>{I18n.t('status')}</label>
              <div>{this.props.reservation.status}</div>
            </div>
          </div>
          <br />
          <br />
          <div className="row">
          <div className="col-sm-6">
            <label>{I18n.t('date_of_booking')}</label>
            <div>{date_of_booking.toString(dateFormat)}</div>
          </div>
            <div className="col-sm-6">
              <label>{I18n.t('cancellation_date')}</label>
              <div>{cancellation_date.toString(dateFormat)}</div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderRoomDetails() {


    return(
      <div className='panel panel-default'>

        <div className="panel-body">
        <h3 className='panel-heading-text'>{I18n.t('rooms')}</h3>
            <DataTable
              endpoint={this.props.reservation_segments_path}
              date_format={this.props.date_format}
              reservation_segments={true}
              tab_data_table={true}
              currency_unit={I18n.t('number.currency.format.unit')}
              delimiter={I18n.t('number.currency.format.delimiter')}
              separator={I18n.t('number.currency.format.separator')} />
        </div>
      </div>
    )
  }

  renderBalance() {
    if (this.props.balance && this.props.balance != 0) {
      return (
        <div className="accommodations-price-footer">
          <p className="lead" style={{marginBottom: 0}}>
            <label style={{marginBottom: 0}}>{I18n.t('reservation_balance_after_cancellation')}:</label>&nbsp;
            {this.formatCurrency(this.props.balance)}
          </p>
        </div>
      );
    } else {
      return null;
    }
  }

  formatCurrency(num) {
    return I18n.t('number.currency.format.unit') + numeral(num / 100).format('0' + I18n.t('number.currency.format.delimiter') + '0.00');
  }


  onChangeNotes(noteText) {
    // console.log("notes", e.target.value);
    let notes = Object.assign({}, this.state.notes)
    notes = noteText
    this.setState({
      notes: notes,
    })
  }

  onCancel() {
    let folio_items = this.props.new_folio_items.map((folioItem) => JSON.stringify(folioItem));

    $.ajax({
      type: 'POST',
      url: this.props.cancel_reservation_path,
      data: {
        folio_items: folio_items,
        notes: this.state.notes,

      },
    }).done(function(data) {
      if (data.errors && data.errors.length) {
        // errors 
      } else {
        if(parent && parent.refresh_data) {
          parent.refresh_data(I18n.t('reservation_canceled_successfully'));
        }

        window.parent.$(window.parent).trigger("reservationCanceledSuccessfully")
        
        if(parent && parent.hide_modal) {
          parent.hide_modal();
        }
      }
    })
  }
}
export default ReservationCancel
